import { atom } from "recoil";

export const closeOnUpdate = atom<boolean>({
  key: "closeOnUpdate",
  default: false,
});
